import React from 'react';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import NewPackageInfoV3 from '@src/containers/Layout/SidebarNew/NewPackageInfoV3';
import actions from '@src/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@src/new-components/Typography';
import NewActionsHeader from '@src/containers/Layout/NewActionsHeader';
import { NEW_ACTIONS_HEADER_MENU } from '@src/constants';
import { StyledListAppsHeader } from '../index.style';

const Header = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();
  const { getFeatureValue } = useFeatureFlags();
  const { id: userId, email, phoneNumber } = user;

  const useInfoCreditsApi = getFeatureValue(FEATURE_KEYS.INFO_CREDITS_API, {
    userId,
    email,
    phoneNumber,
  });

  return (
    <StyledListAppsHeader>
      <Typography variant="body-24-bold">API</Typography>
      {useInfoCreditsApi && (
        <div className="container-btn">
          <NewActionsHeader
            menuShow={[
              NEW_ACTIONS_HEADER_MENU.TASK_CREDIT,
              NEW_ACTIONS_HEADER_MENU.GUIDE_CREDIT,
              NEW_ACTIONS_HEADER_MENU.NOTIFICATION,
              NEW_ACTIONS_HEADER_MENU.LEADERBOARD_VOICE,
            ]}
            onTaskCredits={() =>
              dispatch(actions.layout.setShowOnboardingPopup(true))
            }
            onLeaderboardVoice={() => {
              history.push(ROUTES.VOICE_LEADERBOARD);
            }}
            margin="0px 16px"
          />
          <NewPackageInfoV3 useInfoCreditsApi />
        </div>
      )}
    </StyledListAppsHeader>
  );
};

export default Header;
